import React from "react";
import emptyIMG from "../Assests/placeholder.jpg";
const Image = ({ src, style, className, alt = "img" }) => {
  if (src) {
    return <img src={src} alt={alt} style={style} className={className} />;
  } else {
    return (
      <img src={emptyIMG} alt="not-found" style={style} className={className} />
    );
  }
};

export default Image;
